import api from './api';

async function consultaApi(dados) {

    let conexao = {
        DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
        DBUSERNAME: localStorage.getItem("DBUSERNAME"),
        DBESQUEMA: localStorage.getItem("DBESQUEMA"),
        DBPID: localStorage.getItem("DBPID"),
        MANDNUMBER: localStorage.getItem("MANDNUMBER"),
        EMPNUMBER: localStorage.getItem("EMPNUMBER"),
        USERNUMBER: localStorage.getItem("USERNUMBER")
    };

    const resposta = await api.post('/execute', { ...conexao, ...dados });

    return resposta;
}

export default consultaApi;